import { withInstall } from '@lit-element/utils'

import FullScreen from './src/fullScreen.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtFullScreen: SFCWithInstall<typeof FullScreen> =
  withInstall(FullScreen)
export default LtFullScreen

export * from './src/fullScreen'
